import { FYOption } from '../types';

export const getFyEndYear = (startYear: number, fyOption: FYOption): number =>
  fyOption === 'CALENDAR' ? startYear : startYear + 1;

/** Compact FY label, e.g. "2026-27" for financial or "2026" for calendar. */
export const formatFyLabel = (startYear: number, fyOption: FYOption): string => {
  if (fyOption === 'CALENDAR') {
    return String(startYear);
  }
  const endYear = startYear + 1;
  return `${startYear}-${String(endYear).slice(-2)}`;
};
